export default __webpack_public_path__ + "75cd4dcb7a0e8e379f22585a5345e343.svg";